export default {"src":"/_next/static/media/business.6c44c676.svg","height":72,"width":72};